// src/hooks/jobOrders/useUpdateJobOrder.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateJobOrder } from "../../api/apiJobOrders";
import toast from "react-hot-toast";

const useUpdateJobOrder = () => {
    const queryClient = useQueryClient();

    const { mutate: updateJobOrderMutate, isPending } = useMutation({
        mutationFn: ({ jobOrderId, programId, data }) => updateJobOrder(jobOrderId, data),
        onSuccess: (response, variables) => {
            toast.success("تم تعديل أمر التشغيل بنجاح");
            if (variables.programId) {
                queryClient.invalidateQueries(["job-orders", variables.programId]);
            }
            queryClient.invalidateQueries(["job-order", variables.jobOrderId]);
        },
        onError: (error) => {
            const message = error.response?.data?.message || "حدث خطأ أثناء تعديل أمر التشغيل";
            toast.error(message);
        }
    });

    return { updateJobOrderMutate, isPending };
};

export default useUpdateJobOrder;
